const config = require('../../config/index')

export default config.project
